import { Component, AfterViewInit } from '@angular/core';
import { FormBuilder, } from '@angular/forms';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import {
    Unit, Investor, Property, Category
} from './../../../../../_models';

import { FormNewComponent } from '../../common/form';

@Component({
    selector: 'app-expense-form',
    templateUrl: '../../common/form/form-new.component.html',
    styleUrls: ['../../common/form/form-new.component.scss']
})
export class ExpenseFormComponent extends FormNewComponent implements AfterViewInit {
    endPoint = '/expenses/';
    formHeader = {
        icon: 'fa fa-money',
        text: 'REGISTRAR EGRESO'
    };
    types = [
        { id: 'investor', value: 'Propietario' },
        { id: 'unit', value: 'Unidad' },
        { id: 'property', value: 'Propiedad' }
    ];
    options: any = {
        'investor': {
            model: this.investorModel,
        },
        'unit': {
            model: this.unitModel,
        },
        'property': {
            model: this.propertyModel,
        }
    };
    body: any;
    listGetter: string = "getAllForExpense";
    constructor(
        protected _fbExpenseForm: FormBuilder,
        protected _locationExpenseForm: Location,
        protected routerExpenseForm: Router,
        protected investorModel: Investor,
        protected unitModel: Unit,
        protected propertyModel: Property,
        protected categoryExpenseModel: Category
    ) {
        super(_fbExpenseForm,
            _locationExpenseForm, categoryExpenseModel);
        this.form.controls.type.setValue('lessee');
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid)
                this.body = {
                    expendable_type: this.form.controls['type'].value,
                    expendable_id: this.form.controls['name'].value.id,
                    concept: this.form.controls['concept'].value,
                    amount: this.form.controls['amount'].value,
                    category_id: this.form.controls['category'].value.id,
                    date: this.form.controls['date'].value
                };
        });
    }
    ngAfterViewInit() {
        this.selectTypeData.listing();
        this.selectCategory.listing();
    }
    end() {
        this.routerExpenseForm.navigate([`${this.endPoint}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/expenses/expense-form/expense-form.component.ts